import { Component, inject } from '@angular/core';
import { LaunchDarklyService } from '../../../../../core/services/launchdarkly.service';
import { PendoFeedbackService } from '../../../../../core/services/pendo-feedback.service';

@Component({
    selector: 'app-sidebar2-explore-sub-menu',
    templateUrl: './sidebar2-explore-sub-menu.component.html',
    standalone: false,
})
export class Sidebar2ExploreSubMenuComponent {
    readonly #pendoFeedbackService = inject(PendoFeedbackService);
    readonly exploreMoreWithResources = inject(LaunchDarklyService).get('explore-more-with-resources');

    // @ts-ignore TS7006
    openFeedbackPage(element) {
        this.#pendoFeedbackService.open(element);
    }
}
